<script>
import Register from "@/views/Registers/Register"
export default {
  name: 'IntegrationsRegister',
  extends: Register,
  computed: {
    computedInputsMaster() {
      return [
        { type: 'switch', label: 'Ativo', value: 'active', sm: 4, md: 2 },
        { type: 'switch', label: 'Requer Admin', value: 'requiresAdmin', sm: 4, md: 2 },
        { type: 'divider', label: 'Permissões' },
        { type: 'switch', label: 'Inclusão', value: 'add', sm: 4, md: 2 },
        { type: 'switch', label: 'Gravar ERP', value: 'sync', sm: 4, md: 2 },
        { type: 'switch', label: 'Visualização', value: 'view', sm: 4, md: 2 },
        { type: 'switch', label: 'Edição', value: 'edit', sm: 4, md: 2 },
        { type: 'switch', label: 'Exclusão', value: 'delete', sm: 4, md: 2 },
        { type: 'switch', label: 'Aprovação', value: 'approval', sm: 4, md: 2 },

        { type: 'divider', label: 'Cadastro' },
        { type: 'text-field', label: 'Nome', value: 'name', sm: 4 },
        { type: 'text-field', label: 'Registro', value: 'register', sm: 4 },
        { type: 'text-field', label: 'Coleção', value: 'collection', sm: 4 },
        { type: 'text-field', label: 'Filtro', value: 'filters', sm: 4 },
        { type: 'text-field', label: 'Ordenação', value: 'orderBy', sm: 4 },
        { type: 'text-field', label: 'Coleção de Itens', value: 'collectionDetails', sm: 4 },
        { type: 'text-field', label: 'Campo de bloqueio', value: 'blockedField', sm: 4 },
        { type: 'text-field', label: 'Vínculo Cód. Vendedor', value: 'sallerCodField', sm: 4 },
        { type: 'text-field', label: 'Mensagem de cadastro bem sucedido', value: 'registerSuccessMessage', hint: 'Código JavaScript a ser executado em um eval, deve resultar em uma string.', sm: 4 },
        { type: 'text-field', label: 'Mensagem de edição bem sucedida', value: 'editSuccessMessage', hint: 'Código JavaScript a ser executado em um eval, deve resultar em uma string.', sm: 4 },
        { type: 'text-field', label: 'Mensagem de remoção bem sucedida', value: 'deleteSuccessMessage', hint: 'Código JavaScript a ser executado em um eval, deve resultar em uma string.', sm: 4 },
        { type: 'text-field', label: 'Observação tabela de impostos', value: 'impostosPdfText', hint: 'Visível na exportação do documento PDF abaixo da tabela de impostos', sm: 4 },
        { type: 'text-field', label: 'Observação tabela de totais', value: 'totaisPdfText', hint: 'Visível na exportação do documento PDF abaixo da tabela de totais', sm: 4 },
        { type: 'color-picker', label: 'Cor da tabela no PDF', value: 'colorPdfTable', sm: 4 },
        { type: 'text-field', label: 'Campo Entidade Anexo', value: 'entityField', sm: 4 },
        
        { type: 'divider', label: 'Menu' },
        { type: 'text-field', label: 'Ícone', value: 'listIcon', sm: 4 },
        { type: 'text-field', label: 'Cor do Ícone', value: 'listIconColor', sm: 4 },
        { type: 'text-field', textType: 'number', label: 'Menu Ordem', value: 'menuOrder', sm: 4 },

        { type: 'divider', label: 'Formulário de E-mail' },
        { type: 'text-field', label: 'E-mail Padrão', value: 'emailConfigs.toDefault', sm: 4 },
        { type: 'text-field', label: 'Assunto', value: 'emailConfigs.subjectDefault', sm: 4 },
        { type: 'textarea',  label: "Corpo do Email", value: 'emailConfigs.textDefault', rows: 4 },
        { type: 'switch', label: 'CC?', value: 'emailConfigs.enableCcDefault', sm: 2, default: true },
        { type: 'text-field', label: 'Cc', value: 'emailConfigs.ccDefault', sm: 4 },
        { type: 'switch', label: 'Bcc?', value: 'emailConfigs.enableBccDefault', sm: 2, default: true },
        { type: 'text-field', label: 'Bcc', value: 'emailConfigs.bccDefault', sm: 4 },

        { type: 'divider', label: 'Formulário', help: 'https://koumoul-dev.github.io/vuetify-jsonschema-form/latest/examples/#basic' },
        { 
          type: 'jsoneditor', 
          label: 'Esquema Cabeçalho', 
          value: 'inputsMaster',
          default: [],
          options: {
            mode: 'code',
            templates: [
              {
                label: 'Input Text',
                title: 'Insere um campo de texto',
                className: 'jsoneditor-type-object',
                field: 'campo',
                value: {
                  "type": "string",
                  "order": 1,
                  "title": "título",
                  "x-cols": 12,
                  "x-props": {
                    "outlined": true,
                    "flat": true
                  }
                }
              },
            ]
          },
          help: 'https://koumoul-dev.github.io/vuetify-jsonschema-form/latest/examples/#basic',
          md: 6
        },
        {
          type: 'jsfChild', 
          label: 'Filtros',
          value: 'dataFilters', 
          schema: {
            type: "object",
            allOf: [
              {
                properties: {
                  label: {
                    type: "string",
                    title: "Título",
                  },
                  filterKey: {
                    type: "string",
                    title: "Coluna",
                  },
                  userRules: {
                    type: "array",
                    title: "Papéis com acesso ao filtro",
                    items: {
                      type: "string",
                      oneOf: this.$userRules.map(ur => ({ const: ur.id, title: ur.name }))
                    }
                  }
                }
              },
              {
                type: "object",
                title: "Método",
                oneOf: [
                  {
                    title: "Digitar valores",
                    properties: {
                      source: {
                        type: "string",
                        const: "input",
                      },
                      values: {
                        type: 'array',
                        title: 'Valores',
                        items: {
                          type: 'string',
                        },
                        "x-props": {
                          delimiters: [','],
                          smallChips: true,
                          height: 32,
                        },
                      }
                    }
                  },
                  {
                    title: "Algolia",
                    properties: {
                      source: {
                        type: "string",
                        const: "algolia"
                      },
                      algoliaIndex: {
                        type: "string",
                        title: "Índice",
                      },
                      itemKey: {
                        type: "string",
                        title: "Atributo do item",
                      },
                      fieldsToSearch: {
                        type: 'array',
                        title: 'Atributos a serem buscados',
                        items: {
                          type: 'string',
                        },
                        "x-props": {
                          delimiters: [','],
                          smallChips: true,
                          height: 32,
                        },
                      },
                      fieldsToShow: {
                        type: 'array',
                        title: 'Atributos a serem exibidos na busca',
                        items: {
                          type: 'string',
                        },
                        "x-props": {
                          delimiters: [','],
                          smallChips: true,
                          height: 32,
                        },
                      },
                      multiple: {
                        type: 'boolean',
                        title: 'Seleção múltipla',
                        "x-display": 'switch',
                      },
                      noEmpty: {
                        type: 'boolean',
                        title: 'Exigir texto para realizar a busca',
                        "x-display": 'switch',
                        description: "Essa opção define se os itens referentes ao campo não serão exibidos quando a busca estiver vazia, em caso positivo, será solicitado que o usuário digite para buscar."
                      }
                    }
                  }
                ]
              }
            ]
          }
        },

        { type: 'divider', label: 'Formulário de itens' },
        /**
         * Select que escolhe o tipo do form de details, sua escolha altera os campos logo abaixo
         */
        {
          type: 'select',
          label: 'Tipo do formulário de itens',
          value: 'typeDetails',
          items: [{value: 'none', text: 'Nenhum'}, {value:'data-table', text: 'Tabela'}, {value:'form', text:'Formulário'}],
          default: 'none',
          cols: 12,
        },
        { 
          hide: item => item.typeDetails != 'form',
          send: item => item.typeDetails == 'form',
          type: 'jsoneditor', 
          label: 'Esquema Itens', 
          value: 'schemaDetails',
          options: {
            mode: 'code',
            templates: [
              {
                label: 'Input Text',
                title: 'Insere um campo de texto',
                className: 'jsoneditor-type-object',
                field: 'campo',
                value: {
                  "type": "string",
                  "order": 1,
                  "title": "título",
                  "x-cols": 12,
                  "x-props": {
                    "outlined": true,
                    "flat": true
                  }
                }
              },
            ]
          },
          help: 'https://koumoul-dev.github.io/vuetify-jsonschema-form/latest/examples/#basic',
          md: 6
        },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'tableCollection',
          value: 'tableCollection',
          md: 3,
          sm: 6,
          cols: 12,
        },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'tableIdFrom',
          value: 'tableIdFrom',
          md: 3,
          sm: 6,
          cols: 12,
        },
        // {
        //   hide: item => item.typeDetails != 'data-table',
        //   send: item => item.typeDetails == 'data-table',
        //   type: 'text-field',
        //   label: 'tableItem',
        //   value: 'tableItem',
        //   md: 3,
        //   sm: 6,
        //   cols: 12,
        // },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'tableSubcollection',
          value: 'tableSubcollection',
          md: 3,
          sm: 6,
          cols: 12,
        },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'Ordenação',
          value: 'orderSubcollection',
          md: 3,
          sm: 6,
          cols: 12,
        },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'Filtro de Itens',
          value: 'filterItems',
          hint: 'Código em JavaScript de uma função para filtrar os itens da tabela logo antes de enviar os dados do formulário.',
          md: 9,
          sm: 6,
          cols: 12,
        },
        {
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'text-field',
          label: 'Nome do xlsx',
          value: 'xlsxName',
          md: 3,
          sm: 6,
          cols: 12,
        },
        { 
          hide: item => item.typeDetails != 'data-table',
          send: item => item.typeDetails == 'data-table',
          type: 'jsoneditor', 
          label: 'Headers da Tabela', 
          value: 'headersDetails',
          default: [],
          options: {
            mode: 'code',
            templates: [
              {
                label: 'Input Text',
                title: 'Insere um campo de texto',
                className: 'jsoneditor-type-object',
                field: 'campo',
                value: {
                  "type": "string",
                  "order": 1,
                  "title": "título",
                  "x-cols": 12,
                  "x-props": {
                    "outlined": true,
                    "flat": true
                  }
                }
              },
            ]
          },
          help: 'https://koumoul-dev.github.io/vuetify-jsonschema-form/latest/examples/#basic',
          md: 6
        },
      ]
    },
    computedExportPdf() { return false }
  },
}
</script>

<style>
</style>